var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 165658"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1608",
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#00BB6C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3487_49243",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3487_49243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_2",
    d: "M17.1405 21.3962L14.2738 18.5295C14.0294 18.2851 13.7183 18.1628 13.3405 18.1628C12.9627 18.1628 12.6516 18.2851 12.4072 18.5295C12.1627 18.774 12.0405 19.0851 12.0405 19.4628C12.0405 19.8406 12.1627 20.1517 12.4072 20.3962L16.2072 24.1962C16.4738 24.4628 16.7849 24.5962 17.1405 24.5962C17.496 24.5962 17.8072 24.4628 18.0738 24.1962L25.6072 16.6628C25.8516 16.4184 25.9738 16.1073 25.9738 15.7295C25.9738 15.3517 25.8516 15.0406 25.6072 14.7962C25.3627 14.5517 25.0516 14.4295 24.6738 14.4295C24.296 14.4295 23.9849 14.5517 23.7405 14.7962L17.1405 21.3962ZM19.0072 32.3295C17.1627 32.3295 15.4294 31.9795 13.8072 31.2795C12.1849 30.5795 10.7738 29.6295 9.57383 28.4295C8.37383 27.2295 7.42383 25.8184 6.72383 24.1962C6.02383 22.574 5.67383 20.8406 5.67383 18.9962C5.67383 17.1517 6.02383 15.4184 6.72383 13.7962C7.42383 12.174 8.37383 10.7628 9.57383 9.56284C10.7738 8.36284 12.1849 7.41284 13.8072 6.71284C15.4294 6.01284 17.1627 5.66284 19.0072 5.66284C20.8516 5.66284 22.5849 6.01284 24.2072 6.71284C25.8294 7.41284 27.2405 8.36284 28.4405 9.56284C29.6405 10.7628 30.5905 12.174 31.2905 13.7962C31.9905 15.4184 32.3405 17.1517 32.3405 18.9962C32.3405 20.8406 31.9905 22.574 31.2905 24.1962C30.5905 25.8184 29.6405 27.2295 28.4405 28.4295C27.2405 29.6295 25.8294 30.5795 24.2072 31.2795C22.5849 31.9795 20.8516 32.3295 19.0072 32.3295Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.bd1b323149016139f1496ee330d84df3.svg";
export { ForwardRef as ReactComponent };